import { ContentOption } from '../common/StateSpecification';

export const Dividend_Static_Info = {
  Dividends_Info: `
      <div>
          <p class="content">
              <br>
              <p class="content-bold"><span class="content-bold-underline">Dividends are not guaranteed</span> and are subject to significant fluctuations over the lifetime of the policy. Changes in dividends will change all <nobr>Non-Guaranteed</nobr> values shown in this illustration.</p>
              <br>
              <p>To help you understand how changes in non-guaranteed dividends may affect your future policy values, this Numeric Summary and Signature Page shows how your policy would perform based on each of the following dividend scenarios:</p>
              <br>
              <p style="padding-left: 45px;">1) Guaranteed: The guaranteed policy values, i.e., zero dividends.</p>
              <br>
              <p style="padding-left: 45px;">2) Non-Guaranteed Midpoint: 50% of the Company's currently illustrated dividend.</p>
              <br>
              <p style="padding-left: 45px;">3) Non-Guaranteed Current: The Company's currently illustrated dividend.</p>
              <br>
          </p>
      </div>`,
  Signatures: `
      <div>
        <p class="content">
          <p>{{applicantSignatureText}}</p>
          {{applicantBreaksSignatureText}}
          <table class="table-signature-page">
            <tr>
              <td class="table-signature-page__long table-signature-page__line"></td>
              <td class="table-signature-page__space"></td>
              <td class="table-signature-page__short table-signature-page__line"></td>
            </tr>
            <tr>
              <td class="content">{{APPLICANT_TEXT}}</td>
              <td></td>
              <td class="content">Date</td>
            </tr>
          </table>
          <br>
          <br>
          <p>{{agentSignatureText}}</p>
          {{agentBreaksSignatureText}}
          <table class="table-signature-page">
            <tr>
              <td class="table-signature-page__long table-signature-page__line"></td>
              <td class="table-signature-page__space"></td>
              <td class="table-signature-page__short table-signature-page__line"></td>
            </tr>
            <tr>
              <td class="content">Agent</td>
              <td </td>
              <td class="content">Date</td>
            </tr>
          </table>
        </p>
      </div>`,
  SignatureTextOptions: <SignatureTextOption[]>[
    {
      name: 'Default',
      applicant:
        'I have received a copy of this illustration and understand that any non-guaranteed elements illustrated are subject to significant fluctuations and could be either higher or lower. The agent has told me they are not guaranteed. I understand that this illustration is not a contract. I also understand that any policy changes reflected in this illustration are not automatic, but must be submitted in writing to the Home Office. The terms of the policy constitute the actual agreement of coverage. I further understand I have the right to request a hypothetical lower schedule illustration to see the potential impact of a lower dividend interest rate on my policy values. I have read and understand the IMPORTANT TAX INFORMATION section in the Narrative Summary.',
      agent:
        'I certify that this illustration has been presented to the applicant and that I have explained that any non-guaranteed elements illustrated are subject to change. I have made no statements that are inconsistent with this illustration.',
      applicantBreaks: 3,
      agentBreaks: 3,
    },
    {
      name: 'SignatureTextAK',
      applicant:
        'I  have received a copy of this illustration and understand that any non-guaranteed elements illustrated are subject to significant fluctuations and could be either higher or lower. The person soliciting the policy has told me these elements are not guaranteed. I understand that this illustration is not a contract. I also understand that any policy changes reflected in this illustration are not automatic, but must be submitted in writing to the Home Office. The terms of the policy constitute the actual agreement of coverage. I further understand I have the right to request a hypothetical lower schedule illustration to see the potential impact of a lower dividend interest rate on my policy values. I have read and understand the IMPORTANT TAX INFORMATION section in the Narrative Summary.',
      agent:
        'I certify that this illustration has been presented to the applicant or policyowner and that I have explained that any non- guaranteed elements illustrated are subject to change. I have made no statements that are inconsistent with the illustration.',
      applicantBreaks: 3,
      agentBreaks: 2,
    },
    {
      name: 'SignatureTextIL',
      applicant:
        'I have received a copy of this illustration and understand that this illustration assumes that the current illustrated non-guaranteed elements will continue unchanged for all years shown. This is not likely to occur, and actual results are subject to significant fluctuations and could be either higher or lower. The agent has told me they are not guaranteed. I understand that this illustration is not a contract. I also understand that any policy changes reflected in this illustration are not automatic, but must be submitted in writing to the Home Office. The terms of the policy constitute the actual agreement of coverage. I further understand I have the right to request a hypothetical lower schedule illustration to see the potential impact of a lower dividend interest rate on my policy values. I have read and understand the IMPORTANT TAX INFORMATION section in the Narrative Summary.',
      agent:
        'I have informed the applicant or policyowner that this illustration assumes that the currently illustrated non-guaranteed elements will continue unchanged for all years shown. This is not likely to occur, and actual results may be more or less favorable than those shown.',
      applicantBreaks: 2,
      agentBreaks: 2,
    },
    {
      name: 'SignatureTextNJ',
      applicant:
        'I have received a copy of this illustration. The agent has told me that any non-guaranteed elements illustrated are subject to significant fluctuations and could be either higher or lower. The agent has told me they are not guaranteed. I understand that this illustration is not a contract. I also understand that any policy changes reflected in this illustration are not automatic, but must be submitted in writing to the Home Office. The terms of the policy constitute the actual agreement of coverage. I further understand I have the right to request a hypothetical lower schedule illustration to see the potential impact of a lower dividend interest rate on my policy values. I have read and understand the IMPORTANT TAX INFORMATION section in the Narrative Summary.',
      agent:
        'I certify that this illustration has been presented to the applicant and that I have explained that any non-guaranteed elements illustrated are subject to change. I have made no statements that are inconsistent with this illustration.',
      applicantBreaks: 3,
      agentBreaks: 3,
    },
    {
      name: 'SignatureTextTX',
      applicant:
        'A copy of this illustration has been provided to the Applicant/Policyowner. I have read and understand the IMPORTANT TAX INFORMATION section in the Narrative Summary.',
      agent: '',
      applicantBreaks: 8,
      agentBreaks: 5,
    },
  ],
  Style: `
      .table-signature-page{
        width: 75%;
      }

      .table-signature-page__long {
        width: 60%;
      }

      .table-signature-page__space {
        width: 5%;
      }

      .table-signature-page__short {
        width: 35%;
      }

      .table-signature-page__line {
        border-bottom: 1px solid black;
      }`,
};

interface SignatureTextOption extends ContentOption {
  name: string;
  applicant: string;
  agent: string;
  applicantBreaks: number;
  agentBreaks: number;
}
